import styles from './MemberTable.module.scss'

import Button from '@/components/Button'

interface SeatChangeBarProps {
  pendingCount: number
  isSaving: boolean
  isUnresolved: boolean
  onSave: () => void
  onDiscard: () => void
}

/** Shown while seat changes are staged: Discard or Save them together. */
export const SeatChangeBar = ({ pendingCount, isSaving, isUnresolved, onSave, onDiscard }: SeatChangeBarProps) => {
  if (pendingCount === 0) return null

  const message = isUnresolved
    ? "We couldn't confirm the seat changes. Retry to finish saving them."
    : `${pendingCount} unsaved seat change${pendingCount === 1 ? '' : 's'}`

  return (
    <div className={styles.seatChangeBar}>
      <span className={styles.seatChangeMessage} role="status">
        {message}
      </span>
      {!isUnresolved && <Button type="light" title="Discard" onClick={onDiscard} isDisabled={isSaving} />}
      <Button type="dark" title={isUnresolved ? 'Retry' : 'Save changes'} onClick={onSave} isLoading={isSaving} />
    </div>
  )
}
